import axios from '@/store/config';
import { filter, orderBy } from 'lodash'

export default {
  // state
  state: {
    noteofinterests: [],
    queuePositions: [],
    topQueuePosition: [],
    prelQueuePositions: []
  },

  // getters
  getters: {
    /**
     * Intresseanmälningar. Endast intresserade av 'current'
     */
    noteofinterests: state => {
      return filter(state.noteofinterests, note => note.status == 'current');
    },

    getTopPoints: state => (rentalObjectCode) => {
      const data = state.topQueuePosition.find(d => d.objectCode == rentalObjectCode)
      if (data) return data.points;
      else return 0;
    },

    /**
     * Skicka in ett rentalObjectCode å tar reda på om det tillhör en intresseanmälan.
     */
    isRentalObjectCodeNoteOfInterest: (state) => (rentalObjectCode) => {
      return state.noteofinterests.some(note => note.rentalObjectCode == rentalObjectCode)
    },

    getRentalObjectCodeNoteOfInterest: (state) => (rentalObjectCode) => {
      const data = state.noteofinterests.find(d => d.rentalObjectCode == rentalObjectCode)
      if (data) return data.code;
      else return null;
    },

    getQueuePositionByCode: (state) => (noteOfIntereseCode) => {
      const data = state.queuePositions.find(d => d.noteOfIntereseCode == noteOfIntereseCode)

      if (data)
        return data.position;

      return ""
    },

    getQueuePositionByPoints: (state) => (objectCode) => {
      if (!state.prelQueuePositions) return "-";
      const data = state.prelQueuePositions.find(d => d.objectCode == objectCode)

      if (data)
        return data.position;

      return "";
    }
  },

  // actions
  actions: {
    fetchNoteofinterests ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/applicants/me/noteofinterests')
          .then((response) => {
            commit('setNoteofinterests', response.data);
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },

    /**
     * Skapar intresseanmälan på aktuellt objekt.
     * Uppdaterar även listan över intresseanmälningar
     */
    createNoteofInterest ({ commit, dispatch }, rentalObjectCode) {

      return new Promise((resolve, reject) => {
        axios.post('/NoteOfInterests', {
          "rentalObjectCode": rentalObjectCode
        })
          .then((response) => {
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
              return dispatch('fetchNoteofinterests')
            }, 2000)
          })
          .then(() => {
            resolve();
            return response.data.code;
          })
          .catch((error) => {
            return reject(error);
          });
      })
    },

    removeNoteofInterest ({ commit, dispatch }, contractCode) {
      if (!contractCode) return false;

      return new Promise((resolve, reject) => {

        axios.delete('/noteofinterests/' + contractCode)
          .then((response) => {
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
              return dispatch('fetchNoteofinterests')
            }, 5000)
          })
          .then(() => {
            resolve();
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },

    fetchSingleObjectQueuePostion ({ commit, dispatch }, noteOfIntereseCode) {
      if (!noteOfIntereseCode) return;
        return new Promise((resolve, reject) => {
          axios.get('/noteofinterests/' + noteOfIntereseCode + '/queuePosition')
            .then((response) => {

              commit('pushQueuePositions', { noteOfIntereseCode, position: response.data })
              resolve();
            })
            .catch((error) => {
              return reject(error);
            })
        });
    },

    fetchSingleObjectPrelQueuePostion ({ commit, dispatch }, objectCode) {
      if (!objectCode) return;

        return new Promise((resolve, reject) => {
          axios.get('/noteofinterests/' + objectCode + '/prelQueuePosition')
            .then((response) => {

              commit('pushPrelQueuePositions', { objectCode, position: response.data })
              resolve();
            })
            .catch((error) => {
              return reject(error);
            })
        });
    },

    fetchObjectTopQueuePostion ({ commit, dispatch }, objectCode) {
      if (!objectCode) return;

      return new Promise((resolve, reject) => {
        axios.get('/noteofinterests/' + objectCode + '/topQueuePoints')
          .then((response) => {
            commit('pushTopQueuePositions', { objectCode, points: response.data })
            resolve();
          })
          .catch((error) => {
            return reject(error);
          })
      });
    }
  },

  // mutations
  mutations: {
    setNoteofinterests (state, noteofinterests) {
      state.noteofinterests = noteofinterests;
    },

    pushQueuePositions (state, position) {
      state.queuePositions = state.queuePositions.filter(q => q.noteOfIntereseCode !== position.noteOfIntereseCode);

      state.queuePositions.push(position)
    },

    pushPrelQueuePositions (state, position) {
      state.prelQueuePositions = state.prelQueuePositions.filter(q => q.objectCode !== position.objectCode);

      state.prelQueuePositions.push(position)
    },

    pushTopQueuePositions (state, obj) {
      state.topQueuePosition = state.topQueuePosition.filter(q => q.rentalObjectCode !== obj.rentalObjectCode);
      state.topQueuePosition.push(obj)
    }
  }
}
